// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1tL3t","disabled":"FileBtn_disabled__LBe9s","warn":"FileBtn_warn__3BVMm","fade":"FileBtn_fade__5OnOm"};